import React, { Fragment, useState, useContext, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  TextField,
  Grid,
  Button,
  Card,
  MenuItem,
  OutlinedInput,
  InputAdornment,
  FormHelperText,
} from "@material-ui/core";

import DisputeContext from "../../../../context/paypal/disputes/DisputeContext";

import SpinnerSmall from "../../../layout/SpinnerSmall";

import ConfirmationModal from "./ConfirmationModal";

const FunctionAcceptClaim = ({
  state,
  setState,
  dispute,
  selectedFunction,
  handleClose,
  setReturnedMsg,
}) => {
  const disputeContext = useContext(DisputeContext);
  const { acceptClaim, loading } = disputeContext;

  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmDisplay, setConfirmDisplay] = useState("");

  const [showRefundAmount, setShowRefundAmount] = useState(false);

  useEffect(() => {
    if (
      dispute.reason === "MERCHANDISE_OR_SERVICE_NOT_RECEIVED" ||
      dispute.status !== "WAITING_FOR_SELLER_RESPONSE"
    ) {
      setShowRefundAmount(false);
    } else {
      setShowRefundAmount(true);
    }
  }, [dispute]);

  const claimReason = [
    {
      type: "DID_NOT_SHIP_ITEM",
      label: "Did not ship item",
    },
    {
      type: "TOO_TIME_CONSUMING",
      label: "Too time consuming",
    },
    {
      type: "LOST_IN_MAIL",
      label: "Lost in mail",
    },
    {
      type: "NOT_ABLE_TO_WIN",
      label: "Not able to win",
    },
    {
      type: "COMPANY_POLICY",
      label: "Company Policy",
    },
    {
      type: "REASON_NOT_SET",
      label: "Reason not set",
    },
  ];

  const useStyles = makeStyles((theme) => ({
    modalBody: {
      padding: theme.spacing(2),
    },
    inputWidth: {
      width: "100%",
    },
    helper: {
      color: "#ff3333",
    },
  }));

  const classes = useStyles();

  //Filter Input Value
  const onInputChange = (e) => {
    e.preventDefault();
    e.persist();
    const amountRegex = /^[0-9]+(\.[0-9][0-9]?)?$/g;

    if (e.target.id === "note_value") {
      const value = e.target.value;
      let errors = state.accept_claim.errors;
      let accept_claim = state.accept_claim;
      if (value.length > 2000) {
        errors.note_value = "Maximum 2000 characters";
      } else {
        errors.note_value = "";
      }
      accept_claim.note_value = value;
      setState((state) => ({
        ...state,
        accept_claim: accept_claim,
      }));
    }
    if (e.target.id === "amount_value") {
      const value = e.target.value.trim();
      let errors = state.accept_claim.errors;
      let accept_claim = state.accept_claim;

      if (parseFloat(value) > parseFloat(dispute.dispute_amount.value)) {
        errors.amount_value = "Refund amount is greater than dispute amount.";
      } else if (value === "" || amountRegex.test(value)) {
        errors.amount_value = "";
      } else {
        errors.amount_value = "Invalid Amount Input";
      }
      accept_claim.amount_value = value;
      setState((state) => ({
        ...state,
        accept_claim: accept_claim,
      }));
    }
  };

  const onRefundTypeSelect = (e) => {
    e.preventDefault();
    let accept_claim = state.accept_claim;
    accept_claim.claim_reason = e.target.value;
    setState((state) => ({
      ...state,
      accept_claim: accept_claim,
    }));
  };

  const [isLoading, setIsLoading] = useState();
  const [okClick, setOkCLick] = useState();

  useEffect(() => {
    if (isLoading === true) {
      if (loading === false) {
        handleClose();
        setIsLoading(false);
      }
    }
    //eslint-disable-next-line
  }, [loading]);

  useEffect(() => {
    if (okClick === "accept_claim") {
      acceptClaim(
        dispute.dispute_id,
        state.accept_claim.note_value,
        state.accept_claim.claim_reason,
        state.accept_claim.amount_value,
        dispute.reason,
        dispute.status
      );
      setReturnedMsg("");
      setIsLoading(true);
      setOkCLick("");
    }
    //eslint-disable-next-line
  }, [okClick]);

  const onSubmit = (e) => {
    e.preventDefault();
    setConfirmModal(true);
    var displayReason = "";
    for (let x in claimReason) {
      if (claimReason[x].type === state.accept_claim.claim_reason) {
        displayReason = claimReason[x].label;
      }
    }
    if (showRefundAmount) {
      setConfirmDisplay([
        {
          label: "Reason",
          value: displayReason,
        },
        {
          label: "Refund Amount",
          value: state.accept_claim.amount_value + " USD",
        },
        {
          label: "Note",
          value: state.accept_claim.note_value,
        },
      ]);
    } else {
      setConfirmDisplay([
        {
          label: "Reason",
          value: displayReason,
        },
        {
          label: "Refund Amount",
          value: dispute.dispute_amount.value + " USD",
        },
        {
          label: "Note",
          value: state.accept_claim.note_value,
        },
      ]);
    }
  };

  return (
    <Fragment>
      {" "}
      {selectedFunction === "accept_claim" ? (
        <Grid container direction="column" className={classes.modalBody}>
          <Card className={classes.modalBody}>
            <Grid container direction="column" spacing={2}>
              <Grid item>
                <Grid container direction="row" spacing={1}>
                  <Grid item xs={8}>
                    <TextField
                      label="Accept Claim Reason"
                      variant="outlined"
                      type="text"
                      select
                      id="accept_claim_reason"
                      name="accept_claim_reason"
                      fullWidth
                      value={state.accept_claim.claim_reason}
                      onChange={onRefundTypeSelect}
                      disabled={loading === false ? false : true}
                    >
                      {claimReason.map((each) => (
                        <MenuItem key={each.type} value={each.type}>
                          {" "}
                          {each.label}{" "}
                        </MenuItem>
                      ))}{" "}
                    </TextField>{" "}
                  </Grid>{" "}
                  {showRefundAmount ? (
                    <Grid item xs={4}>
                      <OutlinedInput
                        type="text"
                        id="amount_value"
                        name="amount_value"
                        placeholder="Refund Amount"
                        className={classes.inputWidth}
                        endAdornment={
                          <InputAdornment position="end"> USD </InputAdornment>
                        }
                        value={state.accept_claim.amount_value}
                        onInput={onInputChange}
                        error={
                          state.accept_claim.errors.amount_value ? true : false
                        }
                        disabled={loading === false ? false : true}
                      />{" "}
                    </Grid>
                  ) : null}{" "}
                </Grid>{" "}
              </Grid>{" "}
              <Grid item>
                <TextField
                  type="text"
                  variant="outlined"
                  id="note_value"
                  name="note_value"
                  size="small"
                  fullWidth
                  label="Note"
                  placeholder="Leave a note..."
                  multiline
                  rows={10}
                  maxRows={20}
                  value={state.accept_claim.note_value}
                  onInput={onInputChange}
                  helperText={state.accept_claim.errors.note_value}
                  error={state.accept_claim.errors.note_value ? true : false}
                  disabled={loading === false ? false : true}
                />{" "}
              </Grid>{" "}
              <Grid item xs={12}>
                <Grid
                  container
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                  spacing={2}
                >
                  {showRefundAmount ? (
                    <Grid item>
                      <FormHelperText className={classes.helper}>
                        {" "}
                        {state.accept_claim.errors.amount_value}{" "}
                      </FormHelperText>{" "}
                    </Grid>
                  ) : (
                    <Grid item>
                      <FormHelperText>
                        {" "}
                        {"Note: You're accepting Full Refund " +
                          dispute.dispute_amount.value +
                          " USD"}{" "}
                      </FormHelperText>{" "}
                    </Grid>
                  )}
                  <Grid item>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={onSubmit}
                      disabled={
                        state.accept_claim.note_value.length > 0 &&
                        state.accept_claim.note_value.length <= 2000 &&
                        loading === false &&
                        state.accept_claim.claim_reason &&
                        (showRefundAmount
                          ? state.accept_claim.errors.amount_value === "" &&
                            state.accept_claim.amount_value
                          : true)
                          ? false
                          : true
                      }
                    >
                      {loading ? (
                        <div className="d-flex mx-auto my-auto">
                          <SpinnerSmall />
                        </div>
                      ) : (
                        <Fragment> {"Submit"} </Fragment>
                      )}{" "}
                    </Button>{" "}
                  </Grid>{" "}
                </Grid>{" "}
                <ConfirmationModal
                  confirmModal={confirmModal}
                  setConfirmModal={setConfirmModal}
                  confirmDisplay={confirmDisplay}
                  setConfirmDisplay={setConfirmDisplay}
                  setOkCLick={setOkCLick}
                  selectedFunction={selectedFunction}
                />{" "}
              </Grid>{" "}
            </Grid>{" "}
          </Card>{" "}
        </Grid>
      ) : null}{" "}
    </Fragment>
  );
};

export default FunctionAcceptClaim;
